module.exports = __webpack_public_path__ + "static/img/banner01.537da03.png";


//////////////////
// WEBPACK FOOTER
// ./static/walkInto/banner01.png
// module id = RJcg
// module chunks = 1